import { cn } from "@/lib/cn";

/*
  PLMJ uses a wordmark-only identity (no logo image on plmj.com).
  We recreate it as bold spaced letters in our font stack.
*/

type Props = {
  tone?: "white" | "black";
  className?: string;
  style?: React.CSSProperties;
};

export function PLMJLogo({ tone = "white", className, style }: Props) {
  return (
    <span
      className={cn(
        "inline-flex select-none items-baseline font-semibold tracking-[0.18em]",
        className,
      )}
      style={{
        color: tone === "white" ? "#FFFFFF" : "#0A0E24",
        fontSize: "20px",
        lineHeight: 1,
        letterSpacing: "0.16em",
        ...style,
      }}
      aria-label="PLMJ"
    >
      PLMJ
    </span>
  );
}
